<template>
    <div :class="'hr-text-bg bg-black ' + className +  ( noMargin == true ? ' no-margin' : '')">
        <div class="inner max-w c-white">
            <h3 class="txt-34">{{ title }}</h3>
            <p class="txt-16 mb-0" v-html="text" v-if="text"/>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        className: {
            default: "",
            type: String,
        },
        noMargin: {
            default: false,
            type: Boolean
        },
        title: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        }
    },
};
</script>
